var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rss-content"},[_vm._l((_vm.rssList),function(rssObj,index){return [_c('rss-component',{staticClass:"rss-component",attrs:{"rss-obj":rssObj}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }